import { ApplicationConfigurationRequiredDocumentType, IncomeType } from '@zg-rentals/ts-capps-client';

export const INCOME_DOC_ENCOURAGEMENT_TEXT = {
  [IncomeType.EMPLOYMENT]:
    'To improve your chances of being offered this rental, provide current income documents for the past 2 months, including pay stubs, bank statements, and W-2s.',
  [IncomeType.OTHER]:
    'To improve your chances of being offered this rental, provide documents that show your income, such as tax returns or statements/letters from government agencies or financial institutions.',
  [IncomeType.CONTRACTOR_SELF_EMPLOYED]:
    'To improve your chances of being offered this rental, provide current income documents for the past 2 months, including 1099, bank statements, tax returns, or any other document that shows your income.',
  [IncomeType.HOUSING_VOUCHER]:
    'To improve your chances of being offered this rental, provide an approval letter from a Housing Authority, housing voucher, or any other document that shows the maximum amount of your housing assistance payment.',
};

export const DOCUMENTS_EXPIRED_TEXT =
  'Some or all of the income documents you previously added have expired. Add the latest documents that support this income.';

// Listed by hand, not from the generated _values: the same enum will also carry pet document types
const INCOME_DOCUMENT_TYPES: ReadonlySet<string> = new Set([
  ApplicationConfigurationRequiredDocumentType.BANK_STATEMENTS,
  ApplicationConfigurationRequiredDocumentType.CPA_ATTESTATION,
  ApplicationConfigurationRequiredDocumentType.EMPLOYMENT_VERIFICATION_LETTER,
  ApplicationConfigurationRequiredDocumentType.FORM_1099,
  ApplicationConfigurationRequiredDocumentType.PAY_STUBS,
  ApplicationConfigurationRequiredDocumentType.PROOF_OF_COLLEGE_ACCEPTANCE_OR_ENROLLMENT,
  ApplicationConfigurationRequiredDocumentType.PROOF_OF_OTHER_INCOME,
  ApplicationConfigurationRequiredDocumentType.STATEMENT_OF_ASSETS,
  ApplicationConfigurationRequiredDocumentType.TAX_RETURNS,
  ApplicationConfigurationRequiredDocumentType.W2,
]);

export function isIncomeDocumentType(type: string): type is ApplicationConfigurationRequiredDocumentType {
  return INCOME_DOCUMENT_TYPES.has(type);
}
